import React, { useState } from 'react';
import { Button } from '@mui/material';
import { Toolbar } from 'components';
import { Person } from '@mui/icons-material';
import styled from 'styled-components';
import { Box } from '@mui/material';

const UserToolbar = ({ totalSelected, selectedIds, selected, handleClear }) => (
	<Toolbar open={selectedIds?.length > 0} handleClose={handleClear}></Toolbar>
);

export default UserToolbar;

const StyledButton = styled(Button)`
	margin-right: 10px;
`;
